

import React, { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import 'antd/dist/antd.css';
import "./App.css";
import './Dark.css';
import './Site.css';
import './chrome.scrollbar.css';
import './colorpicker.css';

import Session from "./utils/Session";
import Prefs from "./utils/Prefs";
import Cookies from 'js-cookie';
import SiteRouter from "./utils/SiteRouter";
import { apiCall } from './utils/Api';
import { Alert, Spin, Modal, message, Divider } from 'antd';
import Template from "./utils/Template";
import { defaultTemplate } from "./default_template";
import PubSub from "./utils/PubSub";

function App() {

  const [session, setSession] = useState({ store_id: 0 });
  const [templates, setTemplates] = useState([]);
  const [template, setTemplate] = useState();
  const [loading, setLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(false);



  const allowed_stores = [
    "101069",
    "101070",
    "1119624",
    "1131285",
    "135257",
    "1138810",
    "1115419",
    "1120573",
    "1110174",
    "1110177",
    "11"
  ]



  // Delete the world (only works on tbraunapi)

  // useEffect(() => {
  //   apiCall("site_content/deleteTheWorld", {}, (_status, _result) => {
  //     if(_status){
  //       message.success("Site reset successfully.")
  //     } else {
  //       message.error(_result.error);
  //     }
  //   })
  // }, [])



  // unchanined, assume this will return before gift cards component is used...
  const getGiftCards = () => {
    apiCall("giftcard/getSettings", {}, (_status, _result) => {
      if (_status) {
        window.giftcards = _result.cards.filter(item => item.active);
      }
    })
  }


  const [prefs, setPrefs] = useState({
    editing: false,
    changed: false,
    button_index: 0,
    colour_index: 0,
    content_index: 0,
    style_index: 0,
    search_bar: {
      page: 0,
      name: "Search Bar",
      location: "global",
      component: "search_bar",
      id: "search_bar",
      can_delete: false,
      container: true,
      visibility: "visible",
      expiry_action: false,
      start_date: null,
      end_date: null,
      date_created: 1684428651,
      date_changed: 1684429004,
      data: {},
    },
    nav_bar: {
      page: 0,
      name: "Nav Bar",
      location: "global",
      component: "nav_bar",
      id: "nav_bar",
      can_delete: false,
      container: true,
      visibility: "visible",
      expiry_action: false,
      start_date: null,
      end_date: null,
      date_created: 1684428651,
      date_changed: 1684429004,
      data: {}
    },
    footer_bar: {
      page: 0,
      name: "Footer Bar",
      location: "global",
      component: "footer_bar",
      id: "footer_bar",
      can_delete: false,
      container: true,
      visibility: "visible",
      expiry_action: false,
      start_date: null,
      end_date: null,
      date_created: 1684428651,
      date_changed: 1684429004,
      data: {}
    }
  })


  // Get data for persistant components 
  const setTemp = () => {

    apiCall("site_content/setTemplate", {
      ...defaultTemplate,
      colours: JSON.stringify(defaultTemplate.colours),
      gradients: JSON.stringify(defaultTemplate.gradients),
      buttons: JSON.stringify(defaultTemplate.buttons),
      texts: JSON.stringify(defaultTemplate.texts),
      fonts: JSON.stringify(defaultTemplate.fonts),
      links: JSON.stringify(defaultTemplate.links)
    }, (_status, _result) => {
      if (_status) {
        setTemplates([_result]);
        setTemplate(_result);
      } else {
        message.error(_result.error)
      }
      setLoading(false);
    })
  }

  const fetchTemplates = () => {
    apiCall("site_content/getTemplates", {}, (_status, _result) => {
      if (_status) {
        if (_result.length > 0) {
          setTemplates(_result);
          setTemplate(_result.find(item => item.is_active));
          getGiftCards();
        } else {
          setTemp();
        }
        setLoading(false);
      }
    })
  }

  const convert = () => {
    setFirstLoad(true);
    apiCall("site_content/convertV1ToV3", {}, (_status, _result) => {
      if (_status) {
        fetchTemplates();
      } else {
        message.error(_result.error)
      }
    })
  }

  const drawInitalMessage = () => {
    return (
      <>
        <p>The new Webstore Designer is where all the visual design and layout for your consumer Webstore will be done. Before continuing, there are a few notes to help with the new system (these notes are available on the Help Centre):</p>
        <div className="shim" />
        <div>
          <ul style={{ "marginLeft": "-20px" }}>
            <li>We highly recommend having our Help Centre tutorials on the new Webstore Designer open for reference and FAQs as you explore the new system. Like the Bookmanager software, some functions are intuitive, while others require a little explanation. <br /><a href="https://support.bookmanager.com/tutorials/webstore/webstore-tutorials" rel="noreferrer" target="_blank">Click here to view the Webstore Designer Help Centre Tutorials.</a><div className="shim" /><div className="shim" /></li>
            <li>Your "Site Content" from the old admin site could not be automatically pulled over to the new Webstore Designer. Old content will remain in place, and your consumer Webstore will look identical once you start using the new Webstore Designer. New site pages / menus will need to be added using the new Webstore Designer, and editing an existing page and its content will require you to recreate that page using the new Webstore Designer.<div className="shim" /><div className="shim" /></li>
            <li>You do not need to redo all your site content in one go when you start using the new Webstore Designer. Instead, you can chip away page by page, or only tackle recreating a page when you need to update or add something to an existing page.<div className="shim" /><div className="shim" /></li>
            <li>You can recreate and preview an existing menu / page and its content in the new Webstore Designer while keeping the existing page active and unchanged. Once you have finished creating the replacement page, you can "swap it in" with the click of an "Activate" button.<div className="shim" /><div className="shim" /></li>
            <li>When recreating existing content in the new Website Designer, it is best done by having your current consumer Webstore open in another tab, on the page you wish to recreate. This way, you can quickly copy and paste text, see the order of things, and know which list or image to place. Using two monitors may provide additional efficiency for this task.<div className="shim" /><div className="shim" /></li>
            <li>Book / product lists and Event calendar / page listings will need to be created and managed on the Biz site. Once created, you can then place them using the Webstore Designer. Existing lists and event listings do not need to be recreated if they already exist on Biz.<div className="shim" /><div className="shim" /></li>
            <li>If you edit a product list or Event listing on Biz, you do not need to go back to the Webstore Designer to re-add or update those content blocks. Changes made to lists on Biz will update those lists placed on your consumer Webstore.<div className="shim" /><div className="shim" /></li>
            <li>Images that were previously uploaded on the old admin site will remain active and do not need to be re-uploaded to the new Webstore Designer.<div className="shim" /><div className="shim" /></li>
            <li>We are ending support for placing custom HTML, CSS and JavaScript. We hope that the new Webstore Designer will negate the need for adding source code. If you are unable to achieve a design or layout using the current tools, please let us know so we can look into adding a new content block type for your needs. This will allow us to generate Consumer Webstore content that is responsive and consistent across your customers' devices.<div className="shim" /><div className="shim" /></li>
          </ul>
          <p>To initiate the new Webstore Designer, click "Let's Go!" This will copy over your current Webstore's site navigation (menus and pages). Going forward, you will only be able to make changes to your menus from the new Webstore Designer. Changes made to your menus and navigation on the old admin site will not take effect.</p>
        </div>
      </>
    )
  }

  const checkVersion = (_store_id) => {
    apiCall("site_content/isOnV3", {}, (_status, _result) => {
      if (_status) {
        if (!_result.is_v3) {

          let store = window.sitesettings.stores.find(item => item.cid === _store_id);
          let name = (store.name) ? store.name : "";

          Modal.confirm({
            icon: null,
            title: <div style={{ "marginLeft": "20px" }}>
              <div className="shim" /><div className="shim" />
              <div>{((name) && <span>{name} - </span>)}Welcome to the new Webstore Designer!</div>
              <Divider dashed style={{ "margin": "15px 0px" }} />
            </div>,
            width: 650,
            bodyStyle: { padding: "20px 20px", margin: "0" },
            okText: "Let's Go!",
            content: <div style={{ "maxHeight": "calc(100vh - 400px)", "overflow": "auto", "padding": "20px", "paddingTop": "0px" }}>{drawInitalMessage()}</div>,
            onOk: () => convert(),
            onCancel: () => window.location = "https://biz.bookmanager.com/"
          })

        } else {
          fetchTemplates();
        }
      }
    })

  }


  const getSettings = (_webstore_name, _store_id) => {
    apiCall("store/getSettings", {}, (_status, _result) => {
      if (_status) {
        window.sitesettings = _result;
        apiCall("store/getSettings", { webstore_name: _webstore_name }, (_status, _result) => {
          if (_status) {
            window.storesettings = _result;
            window.cache = Math.round(new Date().getTime() / 1000);
            checkVersion(_store_id);
          }
        }, "customer")
      }
    })
  }

  const getSession = () => {
    apiCall("session/get", {}, (_status, _result) => {
      if (_status) {
        Cookies.set("session_store_id", _result.session_id, { expires: 365 });
        if (!hasAccess(_result)) {
          setLoading(false);
          return;
        }
        if (_result.logged_in) {
          window.store_id = _result.store_id;
          window.san = _result.webstore_name;
          setSession(_result);
          getSettings(_result.webstore_name, _result.store_id);
        } else {
          setSession(_result);
          setLoading(false);
        }
      }
    })
  }

  useEffect(getSession, []);


  const hasAccess = (_session) => {

    if (_session?.permissions?.content) {
      return true;
    } else {
      return false;
    }

  }

  if (loading) {
    return (
      <Spin spinning={loading}>
        <div style={{ "width": "1310px", "margin": "0 auto", "height": "800px" }}></div>
      </Spin>
    );
  }

  if (!hasAccess(session)) {
    return (
      <div style={{ "maxWidth": "500px", "padding": "100px 0px", "margin": "0 auto" }}>
        <Alert
          message={<div style={{"fontWeight" : "400"}}>Access Denied:</div>}
          description={<div>Your account does not have the necessary permissions to use <em>Webstore Designer</em>. To proceed, ensure that your account has been granted <em>Webstore Designer</em> permissions.</div>}
          type="error"
          showIcon
        />
        </div>
    )
  }

  return (
    <>
      <Session value={[session, setSession]}>
        <Prefs value={[prefs, setPrefs]}>
          <Template value={[template, setTemplate]}>
            <PubSub />
            <BrowserRouter basename="/create">
              <SiteRouter firstLoad={firstLoad} templates={templates} />
            </BrowserRouter>
          </Template>
        </Prefs>
      </Session>
    </>
  );
}

export default App;
